export const FETCH_POSTCODES_PENDING = 'FETCH_POSTCODES_PENDING';
export const FETCH_POSTCODES_FULFILLED = 'FETCH_POSTCODES_FULFILLED';
export const FETCH_POSTCODES_FAILED = 'FETCH_POSTCODES_FAILED';
